<template>
	<v-main>
		<v-container>
			<v-card max-width="600" class="mt-4 mx-auto">
				<v-card-title><v-img class="mx-auto" src="logo.png" max-width="300"></v-img></v-card-title>
				<v-card-title class="justify-center">{{ $t('waiting_players') }}</v-card-title>
				<v-card-text>
					<v-list dense>
						<v-divider></v-divider>
						<v-list-item>
							<v-list-item-avatar>
								<v-img
									:alt="`${$store.state.player.name} avatar`"
									:src="$store.state.player.avatar"
								></v-img>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title>
									<span>{{ $store.state.player.name }}</span>
								</v-list-item-title>
							</v-list-item-content>
							<v-list-item-action>
								<span class="font-weight-black">{{ $t('ready') }}</span>
							</v-list-item-action>
						</v-list-item>
						<v-divider></v-divider>
					</v-list>
				</v-card-text>
			</v-card>
		</v-container>
	</v-main>
</template>

<script>
import firebase from "firebase";
export default {
	data() {
		return {
			status: true,
			isStarted: null
		};
	},
	mounted() {
		var playerId = this.$store.state.principal.player_id;
		let vueInstance = this;
		var standardizedhostname = this.$store.state.principal.activity.licensee_id;
		var dbLobby = firebase.database().ref().child("lobby").child(standardizedhostname).child(this.$store.state.principal.activityId);
		var dbPlayer = dbLobby.child("player");
		dbPlayer.on("value", function (snapshot) {
			snapshot.forEach(function (childSnapshot) {
				var childKey = childSnapshot.key;
				var childData = childSnapshot.val();
				if (childKey == playerId) {
					let player = vueInstance.$root.clone(vueInstance.$store.state.player);
					player.is_started = childData.is_started;
					vueInstance.$store.commit("setPlayer", player);
					if (childData.is_started == 0 && vueInstance.status) {
						vueInstance.navigateTo();
						vueInstance.status = false;
					}
				}
			});
		});
	},
	methods: {
		navigateTo() {
			this.$router.push("/games/start/addteam");
		}
	},
	beforeRouteLeave(to, from, next) {
		if (this.$store.state.player.is_started == 0) {
			next()
		} else {
			next(false);
		}
	}
};
</script>
